import { render } from "./FormAgendarAtendimento.vue?vue&type=template&id=9912fab0"
import script from "./FormAgendarAtendimento.vue?vue&type=script&lang=js"
export * from "./FormAgendarAtendimento.vue?vue&type=script&lang=js"

import "./FormAgendarAtendimento.vue?vue&type=style&index=0&id=9912fab0&lang=css"
/* custom blocks */
import block0 from "./FormAgendarAtendimento.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__